export const FACEBOOK = 'https://www.facebook.com/profile.php?id=61559207811352';
export const INSTAGRAM = 'https://www.instagram.com/camp67_kumbh/';
export const TWITTER = 'https://twitter.com/camp67_kumbh/';
export const YOUTUBE = 'https://www.youtube.com/@KumbhSukrit';
export const WHATSAPP = 'https://wa.me/+918485835675';
